export default __webpack_public_path__ + "static/media/470.dc73e709.jpg";